import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface BullhornOutlineSvgProps extends Omit<SvgWrapperProps, 'children'> {}

export const BullhornOutlineSvg = ({
  ...svgProps
}: BullhornOutlineSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 3.13492C14.5 2.41126 13.7551 1.9272 13.0939 2.2211L4.89347 5.86572H3C2.17157 5.86572 1.5 6.5373 1.5 7.36572V10.3657C1.5 11.1941 2.17157 11.8657 3 11.8657H4.5V13.8657C4.5 14.9703 5.39543 15.8657 6.5 15.8657C7.60457 15.8657 8.5 14.9703 8.5 13.8657V13.4682L13.0939 15.51C13.7551 15.8039 14.5 15.3198 14.5 14.5962V11.3157C15.6411 11.0841 16.5 10.0752 16.5 8.86572C16.5 7.65624 15.6411 6.64737 14.5 6.41573V3.13492ZM14.5 7.45108V10.2804C15.0826 10.0745 15.5 9.51883 15.5 8.86572C15.5 8.21261 15.0826 7.65699 14.5 7.45108ZM5.5 13.8657V12.1349L7.5 13.0238V13.8657C7.5 14.418 7.05228 14.8657 6.5 14.8657C5.94772 14.8657 5.5 14.418 5.5 13.8657ZM8.5 12.3657V12.3739L13.5 14.5962L13.5 3.13492L5.5 6.69047V11.0406L8.48153 12.3657H8.5ZM4.5 10.8657V6.86572H3C2.72386 6.86572 2.5 7.08958 2.5 7.36572V10.3657C2.5 10.6419 2.72386 10.8657 3 10.8657H4.5Z"
    />
  </SvgWrapper>
);
